import { motion } from "framer-motion"
import {Users} from 'lucide-react'

export default function FinalCTA() {
  return (
    <section id="cta-final" className="relative bg-white py-16 md:py-24 overflow-hidden">
      {/* Bandeiras sutis ao redor */}
      <div className="absolute top-10 left-6 opacity-10 text-5xl select-none pointer-events-none animate-float">
        &#127482;&#127480;
      </div>
      <div className="absolute bottom-10 right-6 opacity-10 text-5xl select-none pointer-events-none animate-float" style={{ animationDelay: "1s" }}>
        &#127468;&#127463;
      </div>
      <div className="absolute top-1/2 right-10 opacity-5 text-7xl select-none pointer-events-none">
        &#127482;&#127480;
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="font-serif-display text-3xl md:text-4xl lg:text-5xl font-bold text-blue-900 leading-tight mb-4">
            Daqui a 6 meses você pode estar no mesmo lugar.
          </h2>
          <h3 className="font-serif-display text-2xl md:text-3xl lg:text-4xl font-bold text-red-600 mb-3">
            Ou pode estar em outro nível.
          </h3>
          <p className="text-blue-900 text-xl md:text-2xl font-bold mb-8">
            A decisão é sua.
          </p>

          <p className="text-gray-600 text-lg mb-2">
            Você já sabe o que funciona.
          </p>
          <p className="text-gray-600 text-lg mb-10">
            Agora só precisa começar.
          </p>

          <div className="mb-10 flex flex-col items-center gap-3">
            <p className="text-gray-400 text-lg line-through">De R$ 299,40</p>
            <p className="text-3xl md:text-4xl font-bold text-blue-900">Por <span className="text-red-600" style={{ fontSize: '130%' }}>R$ 239,40</span></p>
            <p className="text-green-600 font-semibold text-base">Economize R$ 60,00 🎉</p>

            <a
              href="https://checkout.ewpass.com.br/subscribe/ewpass-semestral"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-button inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-bold text-lg md:text-xl px-10 md:px-14 py-5 md:py-6 rounded-xl shadow-xl shadow-blue-600/30 hover:shadow-blue-600/50 transition-all duration-300 hover:scale-105 animate-pulse-glow mt-3"
            >
              <span className="text-2xl">👉</span> Garantir meu acesso com segurança total
            </a>
          </div>

          <div className="flex flex-col items-center gap-3">
            <div className="flex -space-x-3">
              {[
                "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=100",
                "https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=100",
                "https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=100",
                "https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&w=100",
                "https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&w=100",
                "https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg?auto=compress&cs=tinysrgb&w=100",
                "https://images.pexels.com/photos/1130626/pexels-photo-1130626.jpeg?auto=compress&cs=tinysrgb&w=100",
              ].map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt="aluno"
                  className="w-10 h-10 rounded-full border-2 border-white object-cover shadow"
                />
              ))}
              <div className="w-10 h-10 rounded-full bg-blue-900 border-2 border-white flex items-center justify-center shadow">
                <span className="text-white text-[10px] font-bold">10k+</span>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Users className="w-5 h-5 text-blue-600" />
              <p className="text-blue-900 font-bold text-lg">
                Junte-se a <span className="text-red-600">10.000+</span> alunos que já saíram do básico
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
